import { createSlice } from "@reduxjs/toolkit";
import { fetchPlans, updatePlan, createPlan } from "./PlanManagementThunks";



const initialState  ={
    plans:{
        list:[],
        loading: false,
        error: null,
    }
}


const planManagementSlice = createSlice({
    name:"planManagement",
    initialState,
    reducers:{},

    extraReducers:(builder)=>{
        builder

        .addCase(fetchPlans.pending, (state)=>{
            state.plans.loading = true;
            state.plans.error = null;
        })
        .addCase(fetchPlans.fulfilled, (state, action)=>{
            state.plans.list = action.payload;
            state.plans.loading = false;
        })

        .addCase(fetchPlans.rejected, (state, action)=>{
            state.plans.loading = false;
            state.plans.error = action.error.message || "Failed to load Plans";
        })


        //create Plan
        .addCase(createPlan.pending, (state) => {
              state.plans.loading = true;
              state.plans.error = null;
            })
            .addCase(createPlan.fulfilled, (state) => {
              state.plans.loading = false;
            })
            .addCase(createPlan.rejected, (state, action) => {
              state.plans.loading = false;
              state.plans.error = action.payload || 'Failed to create Plan';
            })


        //update plan
         .addCase(updatePlan.pending, (state)=>{
            state.plans.loading = true;
            state.plans.error = null;
        })
        .addCase(updatePlan.fulfilled, (state, action)=>{
            state.plans.loading = false;
        })

        .addCase(updatePlan.rejected, (state, action)=>{
            state.plans.loading = false;
            state.plans.error = action.error.message || "Failed to update Plans";
        })
    }
})


export default planManagementSlice.reducer;